module.exports = __webpack_public_path__ + "res/Roboto-Regular-webfont.svg?7f5f5571713d4d9916f980c22b832022";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Regular-webfont.svg
// module id = 20
// module chunks = 0